/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: LGPL-2.1-only
 */

:host {
  width: 100%;
  display: flex;
  justify-content: center;
}

div {
  --qds-control-segmented-gap: 4px;
  --qds-control-segmented-padding: 2px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--qds-control-segmented-gap);
  width: fit-content;
  padding: var(--qds-control-segmented-padding);
  background-color: var(--qds-theme-control-slider-track-inactive);
  border-radius: var(--qds-control-border-radius);
}

.stretch {
  width: 100%;

  & ::slotted(*) {
    flex: 1;
  }
}
